import ListDataSadaad from "./ListDataSadaad";
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSadaadData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useRef } from "react";
import ListDataSadaadRenewal from "./SadaadRenewal";
import { checkAccessFn } from "../../../../utils/checkAccess";

export default function Sadaad(props) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const dashboardData = useSelector((state) => state.dashboardData);

  const [trigger, setTrigger] = useState(false);

  const titleBorder = [{ label: "Sadaad", link: "/dashboard/sadaad" }];

  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, [trigger]);

  const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);

  const tabs = useMemo(() => {
    const allowedTabs = [];
    if (checkAccess("SADAAD", "sadad-view")) {
      allowedTabs.push({ id: 0, label: "Sadaad" });
    }
    if (checkAccess("SADAAD", "sadaad-renewal-view")) {
      allowedTabs.push({ id: 1, label: "Sadaad Renewal" });
    }
    return allowedTabs;
  }, [dashboardData]);

  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [selectedStatusrENEW, setSelectedStatusRENEW] = useState("");
  const [selectVisaProviderRENEW, setSelectVisaProviderRENEW] = useState("");

  const [index, setIndex] = useState(-1);

  useEffect(() => {
    if (tabs.length > 0 && index === -1) {
      setIndex(tabs[0].id);
    }
  }, [tabs]);

  const handleindex = (ind) => {
    if (ind === 0) {
      setSelectedStatusRENEW("");
      setSelectVisaProviderRENEW("");
    } else {
      setSelectedStatus("");
      setSelectVisaProvider("");
    }
    setIndex(ind);
  };

  const updateData = () => {
    setTrigger(!trigger);
  };

  if (tabs.length === 0) {
    return (
      <div className="flex justify-center items-center h-40 text-gray-500">
        You do not have permission to view Sadaad or Sadaad Renewal.
      </div>
    );
  }

  return (
    <>
      <div className={`ml-5 mr-5 `}>
        <div className={`ml-5 mr-5`}>
          <div className="flex p-4 gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleindex(tab.id)}
                className={`p-2 px-4 h-10 uppercase text-xs rounded-md transition-colors ${
                  index === tab.id ? "bg-blue text-white" : "bg-white text-black border border-gray-200"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="flex flex-wrap  gap-2 w-full items-center flex flex-row"></div>
        {index === 0 && checkAccess("SADAAD", "sadad-view") ? (
          <ListDataSadaad
            titles={[
              "S.NO.",
              "EMPLOYEE ID",
              "Sadaad Type",
              "BORDER NUMBER",
              "VISA PROVIDER",
              "SPONSOR ID",
              "CLIENT NAME",
              "IQAMA APPLIED DATE",
              "SADAAD NUMBER",
              "Term",
              "STATUS",
              "",
            ]}
            token={token}
            updateData={updateData}
            setTrigger={setTrigger}
            trigger={trigger}
            selectedStatus={selectedStatus}
            setSelectedStatus={setSelectedStatus}
            selectVisaProvider={selectVisaProvider}
            setSelectVisaProvider={setSelectVisaProvider}
          />
        ) : index === 1 && checkAccess("SADAAD", "sadaad-renewal-view") ? (
          <ListDataSadaadRenewal
            titles={[
              "S.NO.",
              "EMPLOYEE ID",
              "Sadaad Type",
              "BORDER NUMBER",
              "Iqama Number",
              "mobile Number",
              "VISA PROVIDER",
              "SPONSOR ID",
              "CLIENT NAME",
              "IQAMA APPLIED DATE",
              "SADAAD NUMBER",
              "Term",
              "STATUS",
              "",
            ]}
            token={token}
            updateData={updateData}
            setTrigger={setTrigger}
            trigger={trigger}
            selectedStatus={selectedStatusrENEW}
            setSelectedStatus={setSelectedStatusRENEW}
            selectVisaProvider={selectVisaProviderRENEW}
            setSelectVisaProvider={setSelectVisaProviderRENEW}
          />
        ) : null}
      </div>
    </>
  );
}
